module.exports = __webpack_public_path__ + "img/bg-clock.5c8a1797.webp";